
// import network from './network'
import networkTS from './networkTS'
import {
  HandoverProtocolServiceUpdatePayload,
  HandoverProtocolServiceUpdateTemplatePayload,
  ObjecthandoverProtocolCreateRequest,
  ObjecthandoverProtocolCreateTemplateRequest
} from '@/types/api'

export default {
  hasHandoverProtocolEnabled(accountId: string) {
    return networkTS.handoverProtocolServiceHasEnabled(accountId)
      .then((response) => {
        return response.data
      })
  },
  enableHandoverProtocol(accountId: string, enable: boolean) {
    return networkTS.handoverProtocolServiceEnable(accountId, { enable: enable })
      .then((response) => {
        return response.data
      })
  },
  handoverProtocolServiceListByObjectIds(objectIds: string[]) {
    return networkTS.handoverProtocolServiceListByObjectIds({ objectIds: objectIds })
      .then((response) => {
        return response.data
      })
  },
  handoverProtocolListByIds(ids: string[]) {
    return networkTS.handoverProtocolServiceListByIds({ ids: ids })
      .then((response) => {
        return response.data
      })
  },
  handoverProtocolServiceDelete(id: string) {
    return networkTS.handoverProtocolServiceDelete(id)
      .then((response) => {
        return response.data
      })
  },
  countMyDrafts() {
    return networkTS.handoverProtocolServiceCountMyDrafts()
      .then((response) => {
        return response.data
      })
  },
  createHandover(handoverProtocol: ObjecthandoverProtocolCreateRequest) {
    return networkTS.handoverProtocolServiceCreate(handoverProtocol)
      .then(response => {
        return response.data
      })
  },
  updateHandover(id: string, handoverProtocol: HandoverProtocolServiceUpdatePayload) {
    return networkTS.handoverProtocolServiceUpdate(id, handoverProtocol)
      .then(response => {
        return response.data
      })
  },
  listAllProtocols(page, itemsPerPage, statuses) {
    return networkTS.handoverProtocolServiceListAllProtocols({ page: page, itemsPerPage: itemsPerPage, statuses: statuses })
      .then((response) => {
        return response.data
      })
  },
  listMyProtocols(page, itemsPerPage, statuses) {
    return networkTS.handoverProtocolServiceListMyProtocols({ page: page, itemsPerPage: itemsPerPage, statuses: statuses })
      .then((response) => {
        return response.data
      })
  },
  createTemplate(handoverProtocol : ObjecthandoverProtocolCreateTemplateRequest) {
    return networkTS.handoverProtocolServiceCreateTemplate(handoverProtocol)
      .then(response => {
        return response.data
      })
  },
  handoverListTemplates(accountId: string) {
    return networkTS.handoverProtocolServiceListTemplates(accountId)
      .then((response) => {
        return response.data
      })
  },
  handoverListTemplatesByPropertyId(propertyId: string) {
    return networkTS.handoverProtocolServiceListTemplatesByPropertyId(propertyId)
      .then((response) => {
        return response.data
      })
  },
  handoverDeleteTemplates(ids: [string]) {
    return networkTS.handoverProtocolServiceDeleteTemplates(ids)
      .then((response) => {
        return response.data
      })
  },
  handoverUpdateTemplate(id: string, handoverProtocol: HandoverProtocolServiceUpdateTemplatePayload) {
    const body = {
      devicesWithoutRoomIds: handoverProtocol.devicesWithoutRoomIds,
      name: handoverProtocol.name,
      templateReferences: handoverProtocol.templateReferences,
      rooms: handoverProtocol.rooms
    }
    return networkTS.handoverProtocolServiceUpdateTemplate(id, body)
      .then(response => {
        return response.data
      })
  },
  setFavoriteTemplate(id: string, favorite: boolean) {
    return networkTS.handoverProtocolServiceSetFavoriteTemplate(id, { favorite: favorite })
      .then(response => {
        return response.data
      })
  },
  handoverListTemplateById(id: string) {
    return networkTS.handoverProtocolServiceGetTemplateById(id)
      .then((response) => {
        return response.data
      })
  },
  handoverProtocolListTemplates(accountId: string) {
    return networkTS.handoverProtocolServiceListTemplates(accountId)
      .then((response) => {
        return response.data
      })
  }
}
